import { composeIO } from 'react-compose-io'
import { parametrosCicloPedidoIO } from './ParametrosCicloPedido.IO'
import ParametrosCicloPedidoView from './ParametrosCicloPedido.View'

export const ParametrosCicloPedido = composeIO(ParametrosCicloPedidoView, parametrosCicloPedidoIO)
